import * as React from 'react'

import { Box, Text, useToggle } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'
import { reaction } from 'mobx'

import { observer } from 'mobx-react'

import EmployeesFilters from 'modules/core/components/Filters'
import Select from 'modules/core/components/Inputs/Select'
import Popover from 'modules/core/components/Popover'
import type FiltersForm from 'modules/core/lib/forms/Filters'
import i18n from 'modules/core/lib/i18n'

import { STATUS } from 'modules/goals/store/models/GoalConfig'

import FilterSelect from '../FilterSelect'

export class GoalsConfigFilters extends Form {
  constructor(values: object) {
    super(values, {
      status: 'string',
    })
  }
}

interface OptionsProps {
  filtersForm: GoalsConfigFilters
  employeesFiltersForm: FiltersForm
  onFilterStatus: (status: string) => void
  onFilterEmployee: (filterBy: string) => void
  canSeeClockedIn: boolean
}

const Options = observer(
  ({
    filtersForm,
    employeesFiltersForm,
    onFilterStatus,
    onFilterEmployee,
    canSeeClockedIn,
  }: OptionsProps) => {
    const statusOptions = [
      {
        value: STATUS.active,
        label: i18n.t('surveys.goals.show.active'),
      },
      {
        value: STATUS.closed,
        label: i18n.t('surveys.goals.show.closed'),
      },
    ]

    const statusField = filtersForm.get('status')
    const filterByField = employeesFiltersForm.get('filterBy')
    React.useEffect(() => {
      return reaction(
        () => filterByField.value,
        (value) => onFilterEmployee(value)
      )
    }, [filterByField.value, onFilterEmployee])

    return (
      <Box padding="s24" gap="s16">
        <Box gap="s8" alignItems="flexStart">
          <Text size="300" weight="medium">
            {i18n.t('surveys.goals.table.filters.title')}
          </Text>
          <Text size="300" color="grey800">
            {i18n.t('surveys.goals.table.filters.description')}
          </Text>
        </Box>
        <Select
          label={i18n.t('surveys.goals.table.filters.status')}
          onChange={() => onFilterStatus(statusField.value)}
          field={statusField}
          options={statusOptions}
          none={i18n.t('filters.filter.none')}
        />
        <Box gap="s4" alignItems="flexStart">
          <Text size="200" weight="medium" color="grey800">
            {i18n.t('surveys.goals.show.table.filters.employees')}
          </Text>
          <EmployeesFilters
            hideFilterByStatus
            hideFirstEmployeeFilter
            showFilterByTeam
            field={filterByField}
            none={i18n.t('filters.filter.none')}
            width="full"
            canSeeClockedIn={canSeeClockedIn}
          />
        </Box>
      </Box>
    )
  }
)
interface Props {
  filtersForm: GoalsConfigFilters
  employeesFiltersForm: FiltersForm
  onFilterStatus: (status: string) => void
  onFilterEmployee: (filterBy: string) => void
  canSeeClockedIn: boolean
}

const Filters = ({
  filtersForm,
  employeesFiltersForm,
  onFilterStatus,
  onFilterEmployee,
  canSeeClockedIn,
}: Props) => {
  const [open, toggle] = useToggle(false)

  return (
    <Box height="full">
      <Popover open={open} toggle={toggle} attachment="top center" size="auto">
        <FilterSelect toggle={toggle} open={open} />
        <Options
          employeesFiltersForm={employeesFiltersForm}
          filtersForm={filtersForm}
          onFilterStatus={onFilterStatus}
          onFilterEmployee={onFilterEmployee}
          canSeeClockedIn={canSeeClockedIn}
        />
      </Popover>
    </Box>
  )
}

export default observer(Filters)
